import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHome,
  faDesktop,
  faMoneyCheckAlt,
  faAddressCard,
  faIdCard,
  faMoneyCheck,
  faCalendarMinus,
  faCalendar,
  faCheckSquare,
  faHandsHelping,
  faPeopleArrows,
  faSearch,
  faUsers,
  faUserTie,
  faAward,
  faIndustry,
  faComments,
  faWarehouse,
  faBoxOpen,
  faUniversity,
  faTable,
  faScaleUnbalanced,
  faCirclePlay,
  faWheatAwn,
  faBookOpen,
  faBarsStaggered,
  faChartLine,
  faShapes,
  faArrowUpWideShort,
  faEarthAmericas,
  faRankingStar,
  faMoneyBillTrendUp,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faHome,
  faDesktop,
  faMoneyCheckAlt,
  faAddressCard,
  faIdCard,
  faMoneyCheck,
  faCalendarMinus,
  faCalendar,
  faCheckSquare,
  faHandsHelping,
  faPeopleArrows,
  faSearch,
  faUsers,
  faUserTie,
  faAward,
  faIndustry,
  faComments,
  faWarehouse,
  faBoxOpen,
  faUniversity,
  faTable,
  faScaleUnbalanced,
  faCirclePlay,
  faWheatAwn,
  faBookOpen,
  faBarsStaggered,
  faChartLine,
  faShapes,
  faArrowUpWideShort,
  faEarthAmericas,
  faRankingStar,
  faMoneyBillTrendUp
);

// import "@fortawesome/fontawesome-free/js/fontawesome";
// import "@fortawesome/fontawesome-free/js/solid";
